<div [ngClass]="{ 'light-theme': !isDarkTheme, 'dark-theme': isDarkTheme }">
  <router-outlet></router-outlet>
</div>
<cube-loader></cube-loader>
